export const facingModeForStage = {
  'front': 'environment',
  'back': 'environment',
  'selfie': 'user'
} as const;

export const backZoom = 1.5;

export const livenessVersion = "2.1";